import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ReactDependentScript from 'react-dependent-script';

import Purchase from '../../components/Purchase';
import { fetchInfoFromVersionColor } from '../../actions';
import { Helmet } from 'react-helmet';
import { GATEWAY_KEYS } from '../../utils/constants';
import PurchaseConfirmation from '../../components/PurchaseConfirmation';
import PurchaseProcessing from '../../components/Purchase/PurchaseProcessing';
import { useState } from 'react';

const PurchaseContainer = ({ showProcessingScreen }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [formValues, setFormValues] = useState({});
  const { version, tipo, modelo, anio } = useParams();
  const { logoUrl, car, isLoading, descuentoWeb } = useSelector(state => ({
    logoUrl: state.personalization.data?.logoUrl,
    car: state.personalization.data || {},
    isLoading: state.personalization.isLoading,
    descuentoWeb: state.personalization?.additional?.descuentoWeb
  }));

  useEffect(() => {
    const carCode = car?.codigo;
    if (carCode === version) return;
    dispatch(fetchInfoFromVersionColor(tipo, modelo, version, anio));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const carCode = car?.codigo;
    if (carCode === version) return;
    dispatch(fetchInfoFromVersionColor(tipo, modelo, version, anio));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <ReactDependentScript
        scripts={["https://credomatic.compassmerchantsolutions.com/js/v1/Gateway.js"]}
      >
        <script>
          <Helmet
          script={[
            { 
              type: 'text/javascript', 
              innerHTML: `if (!window.processor) { window.processor = Gateway.create('${GATEWAY_KEYS.CHECKOUT}');}` 
            }
          ]} />
        </script>
      </ReactDependentScript>
      {!showProcessingScreen  ? (
        <Purchase logoUrl={logoUrl} car={car} isLoading={isLoading} descuentoWeb={descuentoWeb} onShowPurchase={(values) => {
          setFormValues(values);
          history.push('procesando');
        }}/>
      ): (
        <PurchaseProcessing logoUrl={logoUrl} car={car} isLoading={isLoading} descuentoWeb={descuentoWeb} {...formValues} />
      )}
      
    </>
  );
};

export default PurchaseContainer;
